import {NgModule} from '@angular/core';
import {DexTrancheUtilityModule} from '../../components/dex/dex-tranche-utility/dex-tranche-utility.module';
import {ERC20_BALANCES_SHARED_PROVIDERS} from '../../components/dex/dyn-balances/erc20-balances-shared.providers';
import {SecurityModule} from '../../components/security/security.module';
import {DexLastTradeParamsService} from '../../widgets/dex-lp-trade-widget/dex-last-trade-params.service';
import {DexLpTradeFeeService} from '../../widgets/dex-lp-trade-widget/dex-lp-trade-fee.service';
import {DexTradeBgExecService} from '../../widgets/dex-lp-trade-widget/trade-execution/dex-trade-bg-exec.service';
import {DisplayTxHistoryFactory} from '../../widgets/dex-tx-history-widget/display-tx-history.factory';
import {TxStatusMonitoringService} from '../../widgets/dex-tx-history-widget/tx-status-monitoring.service';
import {
    DexFilterOTxByUserWalletsService
} from '../../widgets/dex-tx-history-widget/tx-storage/dex-filter-otx-by-user-wallets.service';
import {TxMonitoringStorageService} from '../../widgets/dex-tx-history-widget/tx-storage/tx-monitoring-storage.service';
import {DashboardResolverService} from './dashboard-resolver.service';
import {DashboardSharedModule} from './dashboard-shared.module';
import {DashboardStorageService} from './dashboard-storage.service';

@NgModule({
    imports: [
        DashboardSharedModule,
        SecurityModule,
        DexTrancheUtilityModule

        // [HED-930] Not used in DEX
        // SmartSecurityModule,
        // AspreaderSecurityModule,
        // AccountDisabledNotificationsModule
    ],
    providers: [
        DashboardStorageService,
        DashboardResolverService,
        ...ERC20_BALANCES_SHARED_PROVIDERS,
        DexLpTradeFeeService,
        DexFilterOTxByUserWalletsService,
        DisplayTxHistoryFactory,
        TxMonitoringStorageService,
        TxStatusMonitoringService,
        DexLastTradeParamsService,
        DexTradeBgExecService
    ],
    exports: [
        DashboardSharedModule
    ]
})
export class ClientDashboardSharedModule {}
